export const formatDateWithHour = (dateString: string) => {
  //format date ISO to Local with hour
  const date = new Date(dateString)
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const hour = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  const dayString = day < 10 ? '0' + day : day
  const monthString = month < 10 ? '0' + month : month
  const hourString = hour < 10 ? '0' + hour : hour
  const minutesString = minutes < 10 ? '0' + minutes : minutes
  const secondsString = seconds < 10 ? '0' + seconds : seconds
  return `${dayString}/${monthString}/${year} ${hourString}:${minutesString}:${secondsString}`
}
